import type { TopBarItem } from '../../components/shell/topBarItems.ts';
import { NotificationCentre } from './NotificationCentre.tsx';

const item: TopBarItem = { id: 'notify', order: 10, Component: NotificationCentre };
export default item;
